import React, { Component } from "react"
import { connect } from 'react-redux'
import { Collapse } from 'react-collapse'

import {
    notebookSection,
    incProtocolPage,
    decProtocolPage,
    goProtocolPage,
    setPageInstructions,
    toggleNotesView
} from '../../../actions'

// Styles
import "./NotesView.scss"

//Icons
import IconNotebook from 'components/icons/notebook-solid';

import { withTranslation } from 'react-i18next'
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger'; 

class NotesView extends Component {

    renderNotes = () => {

      //Return list of tasks for rendering
      let noteCounter = 0;
      const notes = (this.props.tasks.map((page, pageIndex)=>{
        return (<div className="notes-list">
          {page.tasks.map((task, taskIndex)=>{
            const taskComp = (<div>
              <p className="note-task">{this.props.t(pageIndex + 1)+'.'+this.props.t(String.fromCharCode(97 + taskIndex))+' '+this.props.t(task.levels['l'+this.props.level].task)}</p>
              <div>
                {task.notes.map((note)=>{
                  noteCounter++
                  return (<p className="note-text">{note}</p>)
                })}
              </div>
            </div>)

            return taskComp;
          })}
        </div>)
      }))

      if(noteCounter > 0){
        return notes
      } else {
        return (
            <p className="notes-list">
              {this.props.t("No notes found")}
            </p>
        )
      }
    }

    hideNotesView = () => {
      this.props.toggleNotesView(false);
    }


    render() {
        return (
          <Collapse
            isOpened={this.props.notesView}
            theme={{ collapse: 'notes-collapse', content: 'notes-content' }}
            fixedHeight={(window.innerHeight - 100)}>
              <div className="notes-view">
                <div className="notes-head">
                  <div className="back-button">
                    <span>{"< "}</span>
                    <LogEvent
                      logEventProps={{
                        event_type: "sim_protocol_close_notes_btn clicked",
                        event_schema: "track"
                      }}
                      actionProps={{ onClick: { action: 'click' } }}
                      elementType="button"
                    >
                      <button className="back-to-protocol" onClick={this.hideNotesView}>{this.props.t("Back to Protocol")}</button>
                    </LogEvent>
                  </div>
                  <h3>
                    <IconNotebook
                      style={{ color: "white", height: "20px", top: "2px"}}
                    /> {this.props.t("Notes")}
                  </h3>
                </div>
                <div className="notes-body">
                  {this.renderNotes()}
                </div>
              </div>
          </Collapse>
        );
    }
}


NotesView.defaultProps = {
    tasks: []
};

const mapStateToProps = (state) => {
    return {
        sectionSelected: state.notebook.sectionSelected,
        currentPage: state.notebook.currentProtocolPage,
        totalPages: state.notebook.totalProtocolPages,
        pageInstructions: state.notebook.currentPageInstructions,
        focusedTask: state.notebook.focusedTask,
        tasks: state.notebook.taskPages,
        level: state.notebook.level,
        notesView: state.notebook.notesView
    }
}

export default connect(mapStateToProps, {
    notebookSection,
    incProtocolPage,
    decProtocolPage,
    goProtocolPage,
    setPageInstructions,
    toggleNotesView
})(withTranslation()(NotesView));
